import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import { BucketLayout, PageType, BucketRatio } from 'enums';
import { createFetchPageAction, completePageLoad } from 'common/page/actions';
import { fetchScheduleModule, scoreScheduleModule } from 'common/scheduleModule/actions';
import BannerAd from 'common/ads/BannerAd';
import Editorial from 'common/Editorial';
import InContentAd from 'common/ads/InContentAd';
import BucketListContainer from 'common/page/buckets/BucketListContainer';
import MainContainer from 'common/page/common/MainContainer';
import TopLayoutContainer from 'common/page/common/TopLayoutContainer';
import heroSelector from 'common/selectors/heroSelector';
import { notFoundUrl } from 'constants';
import WatchPropTypes from 'common/PropTypes';
import { showOneIdLoginSelector } from 'common/selectors/appSelector';
import { oneIdLoggedInSelector } from 'common/selectors/oneIdSelector';

function renderRedirect() {
    try {
        window.location.href = notFoundUrl;
    } catch (err) {
        console.error(err);
    }
}

export function renderCollection(props) {
    const {
        buckets,
        hero,
        isFetching,
        showOneIdLogin,
        isLoggedIn
    } = props;
    // if there is no bucket list and hero data, redirect to not found page
    if (!buckets.length && Object.keys(hero).length === 0 && isFetching === false) {
        return <div>{renderRedirect()}</div>;
    }

    const bannerAd = [<BannerAd key="banner_ad" />];

    // layout will change depending on presence of editorial description, set some defaults
    let editorial = null;
    let inContentAd = null;
    let layoutOverride = BucketLayout.DEFAULT_UNLIMITED;
    let layoutClass = 'layout-full layout-full--watch';
    let columnClass = 'col-a';

    // if there is a description, show the ad and override to DEFAULT layout with unlimited items
    if (buckets[0] && buckets[0].description) {
        const header = `About ${buckets[0].name}`;
        const content = buckets[0].description;
        editorial = <Editorial header={header} content={content} />;
        inContentAd = <InContentAd exclude={['s', 'm']} />;
        layoutClass = 'layout-bc layout-bc--watch';
        columnClass = 'col-b';
    }

    let renderHeroInBucket = true;
    let hideHeaderLink = false;
    const { metadata: { imageFormat } = {} } = buckets[0] || {};
    if (
        imageFormat === BucketRatio.FiveTwo ||
        imageFormat === BucketRatio.FourThree ||
        imageFormat === BucketRatio.TwoThree
    ) {
        renderHeroInBucket = false;
        layoutOverride = null;
        hideHeaderLink = true;
    }
    const showLogin = !isLoggedIn && showOneIdLogin;
    return (
        <MainContainer pre={bannerAd} showLogin={showLogin}>
            {renderHeroInBucket ? <TopLayoutContainer /> : null}
            <div className={layoutClass}>
                <section className={columnClass}>
                    <BucketListContainer
                        pageType={PageType.COLLECTION}
                        layoutOverride={layoutOverride}
                        key="bucket_list_container"
                        renderHeroInBucket={!renderHeroInBucket}
                        hideHeaderLink={hideHeaderLink}
                    />
                </section>
                <section className="col-c">
                    {editorial}
                    {inContentAd}
                </section>
            </div>
        </MainContainer>
    );
}

renderCollection.propTypes = {
    buckets: PropTypes.arrayOf(WatchPropTypes.bucket),
    isFetching: PropTypes.bool,
    hero: PropTypes.object,
    showOneIdLogin: PropTypes.bool,
    isLoggedIn: PropTypes.bool
};

// create collection-like page(e.g. collection, product)
export default function createCollection(options = {}) {
    const { pageName = 'collection' } = options;

    const Collection = (props) => renderCollection(props);

    Collection.propTypes = {
        buckets: PropTypes.array,
        isFetching: PropTypes.bool,
        hero: PropTypes.object
    };

    Collection.loadActions = [
        (params, query, lang) => createFetchPageAction(pageName, params, query, lang),
        (params, query, lang) => fetchScheduleModule(lang)
    ];

    Collection.refreshInterval = 65; // 1 min and 5 secs
    Collection.onRefresh = ({ dispatch, routeParams, lang, location: { query = {} } }) => {
        dispatch(createFetchPageAction(Collection.pageName, routeParams, query, lang))
            .then(() => {
                dispatch(completePageLoad());
            });
        dispatch(fetchScheduleModule(lang))
            .then(() => {
                dispatch(scoreScheduleModule());
            });
    };

    const mapStateToProps = (state) => ({
        buckets: (state.page && state.page.buckets) || [],
        isFetching: (state.page && state.page.isFetching),
        hero: heroSelector(state),
        showOneIdLogin: showOneIdLoginSelector(state),
        isLoggedIn: oneIdLoggedInSelector(state)
    });

    return connect(mapStateToProps)(Collection);
}



// WEBPACK FOOTER //
// ./app/common/createCollection.js